<template>
  <header>
    <h1>RS Democlient {{ app_version }}</h1>
    <div v-if="store.user.username" class="userinfo">
      <div class="env-badge" v-if="store.environment">{{ store.environment.name }}</div>
      Logged in as: {{ store.user.username }} - <a href="#" @click.stop="logout">Log out</a><br>
      Balance: {{ store.user.balance.total }} SEK
    </div>
  </header>
  <MainMenu />
  <main>
    <EnvironmentSelect v-if="store.page == 'env'" />
    <LoggedIn v-if="store.page == 'loggedin'" />
    <Gamification v-if="store.page == 'gamification'" />
    <Jackpot v-if="store.page == 'jackpot'" />
    <Instant v-if="store.page == 'instant'" />
    <Lotto v-if="store.page == 'lotto'" />
    <Raffle v-if="store.page == 'raffle'" />
    <WinLose v-if="store.page == 'winlose'" />
    <Probability v-if="store.page == 'probability'" />
    <Cashout v-if="store.page == 'cashout'" />
    <Transactions v-if="store.page == 'transactions'" />
      <Crash v-if="store.page == 'crash'" />
  </main>
</template>

<script>
import MainMenu from './components/MainMenu.vue'
import EnvironmentSelect from './components/EnvironmentSelect.vue'
import LoggedIn from './components/LoggedIn.vue'
import Jackpot from './components/Jackpot.vue'
import Raffle from './components/Raffle.vue'
import WinLose from './components/WinLose.vue'
import Probability from './components/Probability.vue'
import Transactions from './components/Transactions.vue'
import Gamification from './components/Gamification.vue'
import Instant from './components/Instant.vue'
import Cashout from './components/Cashout.vue'
import Lotto from './components/Lotto.vue'
import Crash from './components/Crash.vue'
import store from './store.js';



export default {
  name: 'App',
  data() {
    return {
      store,
      app_version: process.env.VUE_APP_VERSION
    }
  },
  components: {
    MainMenu,
    EnvironmentSelect,
    LoggedIn,
    Gamification,
    Jackpot,
    Raffle,
    Lotto,
    Crash,
    WinLose,
    Probability,
    Transactions,
    Instant,
    Cashout
  },
  methods: {
    logout() {
      store.page = 'env';
      store.user = {};
      store.clientConfig = null;
      store.environment = null;
      store.apiBaseUrl = null;
      store.users = [];
    }
  }
}
</script>

<style>
:root {
  --color-green: #9fd0b0;
  --color-yellow: #dbb230;
  --color-blue: #1b2c4d;
  --color-text-light: #fff;
  --color-text-dark: var(--color-blue);
  --color-disabled: grey;
}
html {
  height: 100%
}
body {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  min-height: 100%;
  background: #fff;
  color: #1b2c4d;
  margin:0;
  padding:0;
}
#app {
  color: var(--color-text-dark);
}

header {
  background: var(--color-green);
  padding: 10px 20px;
  display: flex;
}
header h1 {
  margin: 0;
  padding: 0;
}
header .userinfo {
  font-size: 0.85em;
  margin-left: auto;
  text-align: right;
}
header .userinfo a {
  text-decoration: underline;
}
.env-badge {
  display: inline-block;
  background: var(--color-blue);
  color: var(--color-text-light);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75em;
  font-weight: 600;
  margin-right: 8px;
}
main {
  padding: 20px;
}

h1, h2, h3, h4 {
  font-family: Aleo;
  font-weight: 700;
}
h5,h6 {
  font-family: Montserrat;
  font-weight: 600;
}
button, .button {
  border: 0;
  font-size: 1em;
  padding: 0.5em 1em;
  background: var(--color-blue);
  color: var(--color-text-light);
  padding: 0.5em 1em;
  border-radius: 0.3em;
  margin: 0.3em;
}
button:disabled, .button:disabled, button.disabled, .button.disabled {
  background: var(--color-disabled);
}
input[type=text], input[type=number] {
  padding: 0.5em;
}


.overlay-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.3);
  z-index: 1000;
}
.overlay-loading:before {
  position: absolute;
  left: 50%;
  top: 50%;
  border: 4px solid var(--color-text-light);
  border-radius: 50%;
  border-top-color: transparent;
  border-bottom-color: transparent;
  width: 60px;
  height: 60px;
  content: '';
  animation: rotate360deg 1.25s infinite linear;
}

@keyframes rotate360deg {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}



</style>
